import { render } from "./IfBlockComponent.vue?vue&type=template&id=37235d16&scoped=true"
import script from "./IfBlockComponent.vue?vue&type=script&lang=js"
export * from "./IfBlockComponent.vue?vue&type=script&lang=js"

import "./IfBlockComponent.vue?vue&type=style&index=0&id=37235d16&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-37235d16"

export default script